export function floorHour(unixSeconds: number): number {
  return Math.floor(unixSeconds / 3600) * 3600;
}

/** bigint token amount -> float in whole units. Safe for < 2^53 base units per whole. */
export function fromUnits(value: bigint, decimals: number): number {
  return Number(value) / 10 ** decimals;
}

/** ray (1e27) per-second-compounded APR in Aave terms -> fraction. */
export function rayToFraction(ray: bigint): number {
  return Number(ray) / 1e27;
}

/** Arithmetic mean of the non-null values; null when there are none. */
export function mean(values: (number | null)[]): number | null {
  const xs = values.filter((v): v is number => v !== null && Number.isFinite(v));
  return xs.length > 0 ? xs.reduce((a, b) => a + b, 0) / xs.length : null;
}

export function fmtCompact(n: number | null, unit = ''): string {
  if (n === null || !Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  const f = (v: number, s: string) => `${(n < 0 ? '-' : '')}${v.toFixed(v >= 100 ? 0 : v >= 10 ? 1 : 2)}${s}`;
  const body =
    abs >= 1e9 ? f(abs / 1e9, 'B') : abs >= 1e6 ? f(abs / 1e6, 'M') : abs >= 1e3 ? f(abs / 1e3, 'K') : f(abs, '');
  return unit ? `${body} ${unit}` : body;
}

export function fmtPct(fraction: number | null, digits = 1): string {
  if (fraction === null || !Number.isFinite(fraction)) return '—';
  return `${(fraction * 100).toFixed(digits)}%`;
}

export function fmtSignedPct(fraction: number | null, digits = 1): string {
  if (fraction === null || !Number.isFinite(fraction)) return '—';
  const s = (fraction * 100).toFixed(digits);
  return fraction > 0 ? `+${s}%` : `${s}%`;
}
